import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { render, unmountComponentAtNode } from "react-dom"
import { NavigationProvider, TLOContextProvider } from "web/contexts"
import { useDeal } from "web/hooks/data"
import React, { Suspense } from "react"
import DealAssets from "web/app/Deals/ViewDeal/DealAssets"

export default class DealAssetsController extends Controller {
  static values = {
    basePath: String,
    dealId: Number,
    viewGroup: Object,
    viewId: Number,
    selectedIds: Array,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const DealTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider subjectType="deal" data={useDeal(this.dealIdValue)}>
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <NavigationProvider
                viewGroup={this.viewGroupValue}
                viewId={this.viewIdValue}
                subjectType="deal"
              >
                <DealTLOContextProvider>
                  <ErrorBoundary>
                    <DealAssets
                      rootUrl={this.basePathValue}
                      canRedirectToRootUrl={false}
                      selectedIds={this.selectedIdsValue}
                    />
                  </ErrorBoundary>
                </DealTLOContextProvider>
              </NavigationProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
